<c-row>
  <c-col xs="12">
    <c-card class="mb-4 shadow">
      <c-card-header ngPreserveWhitespaces>
        <c-row>
          <c-col>
            <strong>Subscriptions</strong>
          </c-col>
        </c-row>
      </c-card-header>
      <c-card-body>
        <c-col xs="12">
          <c-col xs="12">
            <c-smart-table [activePage]="1" [columnSorter]="true" [columns]="LicensesColumns"
              [itemsPerPageSelect]="true" [itemsPerPage]="10" [items]="LicensesDataToShow"
              [sorterValue]="{ column: 'name', state: 'asc' }" [tableFilter]="true" tableFilterLabel="Search:"
              tableFilterPlaceholder="Type Here" noItemsLabel="No Record Found"
              [tableProps]="{ hover: true, responsive: true }" [tableBodyProps]="{ align: 'middle' }" header pagination
              [loading]="Loading">
              <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item"
                let-tdContent="tdContent">
                <td>
                  <ng-container [ngSwitch]="columnName">
                    <!-- Product Name with Demo Badge -->
                    <ng-container *ngSwitchCase="'productName'">
                      {{ tdContent }}
                      <c-badge *ngIf="item.isTrial" color="warning" shape="rounded-pill" class="ms-2">
                        Demo
                      </c-badge>
                    </ng-container>

                    <!-- Actions column with Manage button -->
                    <ng-container *ngSwitchCase="'Actions'">
                      <button *ngIf="!item.isTrial" (click)="openManageModal(item)" cButton color="primary" size="sm"
                        variant="outline" class="me-1 mb-1">
                        <svg cIcon name="cilSettings" size="sm" class="me-1"></svg>
                        Manage Plan
                      </button>
                      <button (click)="ShowLicenseDetails(item)" cButton color="info" size="sm" variant="ghost"
                        class="mb-1">
                        <svg cIcon name="cilInfo" size="sm"></svg>
                      </button>
                    </ng-container>

                    <!-- Format dates -->
                    <ng-container *ngSwitchCase="'dateUpdatedUTC'">
                      {{ tdContent | date : "MM/dd/yyyy" }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'date_Start'">
                      {{ tdContent | date : "MM/dd/yyyy" }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'date_Expire'">
                      {{ item.isTrial ? "Unlimited" : (tdContent | date : "MM/dd/yyyy") }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'isActive'">
                      {{ tdContent ? "Active" : "Inactive" }}
                    </ng-container>

                    <!-- Default -->
                    <ng-container *ngSwitchDefault>
                      {{ tdContent }}
                    </ng-container>
                  </ng-container>
                </td>
              </ng-template>
            </c-smart-table>
          </c-col>
        </c-col>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>


<c-modal #LicenseModal alignment="center" id="LicenseModal" size="xl" backdrop="static"
  [visible]="ModalVisibleLicenseDetails">
  <c-modal-header>
    <h5 cModalTitle>License Detail</h5>
    <button (click)="toggleModalLicenseDetails()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <c-row *ngIf="licenseData != null">
      <div class="container">
        <h6>Client Name : {{ UserData.userDisplayName }}</h6>
        <h6>License Key : {{ licenseData?.license_Code }}</h6>
        <h6>Plan Name : {{ licenseData?.plan?.planName }}</h6>

        <table cTable cTableColor="info">
          <thead cTableColor="dark">
            <tr>
              <th scope="col">Product Name & Features List</th>

            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr>
                <th>
                  {{ licenseData?.productName }}
                </th>

              </tr>
              <!-- Plan-level features from plan.planDetail -> productFeaturess -->
              <ng-container *ngIf="licensePlanFeatures && licensePlanFeatures.length > 0">
                <tr>
                  <td colspan="6" class="pt-2 pb-0">
                    <strong>Plan Features ({{ licensePlanFeatures.length }})</strong>
                  </td>
                </tr>
                <ng-container *ngFor="let pfeature of licensePlanFeatures">
                  <tr>
                    <td style="padding-left: 60px">
                      {{ pfeature.featureName }}
                      <div class="small text-muted" *ngIf="pfeature.moduleName && pfeature.moduleName !== 'General'">
                        {{ pfeature.moduleName }}
                      </div>

                    </td>

                  </tr>
                </ng-container>
              </ng-container>
              <!-- <ng-container
                *ngFor="let feature of licenseData?.license_Features"
              >
                <tr>
                  <td style="padding-left: 60px">
                    {{ feature.featureName }}
                  </td>
                  <td>
                    {{ feature.date_Start | date : "MM/dd/yyyy" }}
                  </td>
                  <td>
                    {{ feature.date_End | date : "MM/dd/yyyy" }}
                  </td>
                  <td>
                    {{ licenseData.extraStores }}
                  </td>
                  <td>
                    {{ feature.isTrial ? "Yes" : "No" }}
                  </td>
                  <td>
                    {{ feature.isActive ? "Yes" : "No" }}
                  </td>
                </tr>
              </ng-container> -->
            </ng-container>
          </tbody>
        </table>
      </div>
    </c-row>
    <!-- <button class="btn btn-primary mt-2 mb-1" [cModalToggle]="LicenseModal.id">
        Submit
      </button> -->
  </c-modal-body>
</c-modal>


<!-- Upgrade Modal -->
<c-modal [(visible)]="upgradeModalVisible" alignment="center" backdrop="static" size="md">
  <c-modal-header>
    <h5 class="modal-title">Upgrade License</h5>
    <button type="button" class="btn-close" (click)="upgradeModalVisible=false"></button>
  </c-modal-header>

  <c-modal-body>
    <div class="mt-2">
      <label class="fw-bold mb-2">Choose Upgrade Option:</label>
      <div class="d-flex flex-column gap-2">
        <button cButton color="primary" variant="{{ selectedUpgrade === 'stores' ? 'solid' : 'outline' }}"
          (click)="selectedUpgrade = 'stores'">
          Increase No of Stores
        </button>
        <button cButton color="primary" variant="{{ selectedUpgrade === 'features' ? 'solid' : 'outline' }}"
          (click)="selectedUpgrade = 'features'">
          Add More Features
        </button>
      </div>
    </div>
  </c-modal-body>

  <c-modal-footer>
    <button cButton color="secondary" (click)="upgradeModalVisible=false">
      Cancel
    </button>
    <button cButton color="success" [disabled]="!selectedUpgrade" (click)="confirmUpgrade(selectedUpgrade)">
      Confirm
    </button>
  </c-modal-footer>
</c-modal>

<!-- Downgrade Modal -->
<c-modal [(visible)]="downgradeModalVisible" alignment="center" backdrop="static" size="md">
  <c-modal-header>
    <h5 class="modal-title">Downgrade License</h5>
    <button type="button" class="btn-close" (click)="downgradeModalVisible=false"></button>
  </c-modal-header>

  <c-modal-body>
    <div class="mt-2">
      <label class="fw-bold mb-2">Choose Downgrade Option:</label>
      <div class="d-flex flex-column gap-2">
        <button cButton color="primary" variant="{{ selectedDowngrade === 'stores' ? 'solid' : 'outline' }}"
          (click)="selectedDowngrade = 'stores'">
          Reduce No of Stores
        </button>
        <button cButton color="primary" variant="{{ selectedDowngrade === 'features' ? 'solid' : 'outline' }}"
          (click)="selectedDowngrade = 'features'">
          Remove Features
        </button>
      </div>
    </div>
  </c-modal-body>

  <c-modal-footer>
    <button cButton color="secondary" (click)="downgradeModalVisible=false">
      Cancel
    </button>
    <button cButton color="primary" [disabled]="!selectedDowngrade" (click)="confirmDowngrade(selectedDowngrade)">
      Confirm
    </button>
  </c-modal-footer>
</c-modal>


<!-- Plan Selection Modal -->
<c-modal [(visible)]="planSelectionModalVisible" alignment="center" backdrop="static" size="xl" scrollable>
  <c-modal-header>
    <h5 cModalTitle>
      <svg cIcon name="cilGrid" class="me-2"></svg>
      Choose Your Plan
    </h5>
    <button (click)="cancelPlanChange()" cButtonClose></button>
  </c-modal-header>

  <c-modal-body class="plan-selection-body">
    <!-- Loading State -->
    <div *ngIf="loadingPlans" class="text-center py-5">
      <c-spinner color="primary"></c-spinner>
      <p class="mt-3 text-muted">Loading available plans...</p>
    </div>

    <!-- Plans Grid -->
    <c-row *ngIf="!loadingPlans && availablePlans.length > 0" class="g-4">
      <c-col *ngFor="let plan of availablePlans" xs="12" md="6" lg="4">
        <c-card class="plan-card h-100 shadow-sm" [ngClass]="{
            'current-plan': (selectedLicense?.planMaster_Id === plan.id || selectedLicense?.plan_Id === plan.id || selectedLicense?.plan?.id === plan.id),
            'upgrade-plan': getPlanBadgeColor(plan) === 'success',
            'downgrade-plan': getPlanBadgeColor(plan) === 'warning'
          }">
          <c-card-header class="text-center ">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h5 class="mb-0 fw-bold">{{ plan.planName }}</h5>
              <c-badge *ngIf="getPlanBadgeText(plan)" [color]="getPlanBadgeColor(plan)" shape="rounded-pill">
                {{ getPlanBadgeText(plan) }}
              </c-badge>
            </div>
            <div class="plan-price">
              <span class="h3 fw-bold text-primary">${{ getPlanTotal(plan) }}</span>
              <span class="text-muted">{{ getBillingFrequency() }}</span>
            </div>
            <div class="small text-muted mt-1" *ngIf="plan.isDemo">
              <svg cIcon name="cilClock" class="me-1"></svg>
              Trial Plan
            </div>
          </c-card-header>

          <c-card-body>
            <!-- Features List -->
            <div class="features-list">
              <h6 class="fw-semibold mb-3">
                <svg cIcon name="cilCheckCircle" class="me-1"></svg>
                Features ({{ plan.details.length }}):
              </h6>
              <ul class="list-unstyled">
                <li *ngFor="let feature of plan.details" class="mb-2 d-flex align-items-start">
                  <svg cIcon name="cilCheckAlt" class="text-success me-2 mt-1 flex-shrink-0"></svg>
                  <div class="flex-grow-1">
                    <span>{{ feature.featureName }}</span>
                    <div class="small text-muted" *ngIf="feature.moduleName && feature.moduleName !== 'General'">
                      {{ feature.moduleName }}
                    </div>
                    <div class="small text-info"
                      *ngIf="feature.price > 0 || (selectedLicense?.extraStores > 0 && feature.priceExtraStore > 0)">
                      <div *ngIf="feature.price > 0">
                        ${{ getFeaturePrice(feature.price) }}{{ getBillingFrequency() }}
                        <span *ngIf="feature.priceOneTime > 0"> + ${{ feature.priceOneTime }} one-time</span>
                      </div>
                      <div *ngIf="selectedLicense?.extraStores > 0 && feature.priceExtraStore > 0" class="mt-1">
                        + ${{ getFeaturePrice(feature.priceExtraStore * selectedLicense.extraStores) }} for {{
                        selectedLicense.extraStores }} Extra Store(s)
                      </div>
                    </div>
                  </div>
                </li>
                <li *ngIf="!plan.details || plan.details.length === 0" class="text-muted">
                  <svg cIcon name="cilInfo" class="me-2"></svg>
                  No features available
                </li>
              </ul>
            </div>
          </c-card-body>

          <c-card-footer class="bg-transparent border-top-0">
            <button cButton
              [color]="(selectedLicense?.planMaster_Id === plan.id || selectedLicense?.plan_Id === plan.id || selectedLicense?.plan?.id === plan.id) ? 'secondary' : getPlanBadgeColor(plan)"
              class="w-100"
              [disabled]="selectedLicense?.planMaster_Id === plan.id || selectedLicense?.plan_Id === plan.id || selectedLicense?.plan?.id === plan.id"
              (click)="selectPlan(plan)">
              <svg cIcon name="cilArrowRight" class="me-1"></svg>
              {{ (selectedLicense?.planMaster_Id === plan.id || selectedLicense?.plan_Id === plan.id ||
              selectedLicense?.plan?.id === plan.id) ? 'Current Plan' : 'Select Plan' }}
            </button>
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>

    <!-- No Plans Available -->
    <div *ngIf="!loadingPlans && availablePlans.length === 0" class="text-center py-5">
      <svg cIcon name="cilWarning" size="3xl" class="text-warning mb-3"></svg>
      <h5>No Plans Available</h5>
      <p class="text-muted">There are no plans available for this product at the moment.</p>
    </div>
  </c-modal-body>

  <c-modal-footer>
    <button cButton color="secondary" (click)="cancelPlanChange()">
      Cancel
    </button>
  </c-modal-footer>
</c-modal>


<!-- Confirmation Modal -->
<c-modal [(visible)]="confirmationModalVisible" alignment="center" backdrop="static" size="lg">
  <c-modal-header>
    <h5 cModalTitle>
      <svg cIcon [name]="featureComparison?.isUpgrade ? 'cilArrowTop' : 'cilArrowBottom'" class="me-2"></svg>
      Confirm Plan {{ featureComparison?.isUpgrade ? 'Upgrade' : featureComparison?.isDowngrade ? 'Downgrade' : 'Change'
      }}
    </h5>
    <button (click)="cancelPlanChange()" cButtonClose [disabled]="processingPlanChange"></button>
  </c-modal-header>

  <c-modal-body *ngIf="featureComparison">
    <!-- Plan Summary -->
    <c-row class="mb-4">
      <c-col xs="12">
        <c-alert [color]="featureComparison.isUpgrade ? 'success' : featureComparison.isDowngrade ? 'warning' : 'info'"
          class="d-flex align-items-center">
          <svg cIcon [name]="featureComparison.isUpgrade ? 'cilCheckCircle' : 'cilInfo'" class="flex-shrink-0 me-2"
            size="xl"></svg>
          <div>
            <strong>Plan Change Summary</strong>
            <p class="mb-0 mt-1">
              You are {{ featureComparison.isUpgrade ? 'upgrading' : featureComparison.isDowngrade ? 'downgrading' :
              'switching' }}
              from <strong>{{ featureComparison.currentPlan.planName }}</strong>
              (${{ getPlanTotal(featureComparison.currentPlan) }}{{ getBillingFrequency() }})
              to <strong>{{ featureComparison.targetPlan.planName }}</strong>
              (${{ getPlanTotal(featureComparison.targetPlan) }}{{ getBillingFrequency() }})
            </p>
          </div>
        </c-alert>
      </c-col>
    </c-row>

    <!-- Features Comparison -->
    <c-row class="g-3">
      <!-- Features to Add -->
      <c-col xs="12" md="6" *ngIf="featureComparison.featuresToAdd.length > 0">
        <c-card class="h-100 border-success">
          <c-card-header class="bg-success-subtle">
            <h6 class="mb-0 text-success fw-semibold">
              <svg cIcon name="cilPlus" class="me-2"></svg>
              Features to Add ({{ featureComparison.featuresToAdd.length }})
            </h6>
          </c-card-header>
          <c-card-body>
            <ul class="list-unstyled mb-0">
              <li *ngFor="let feature of featureComparison.featuresToAdd" class="mb-2 d-flex align-items-start">
                <svg cIcon name="cilCheckAlt" class="text-success me-2 mt-1 flex-shrink-0"></svg>
                <div>
                  <span>{{ feature.featureName }}</span>
                  <div class="small text-muted" *ngIf="feature.moduleName && feature.moduleName !== 'General'">
                    {{ feature.moduleName }}
                  </div>
                  <div class="small text-info" *ngIf="feature.price > 0">
                    ${{ getFeaturePrice(feature.price) }}{{ getBillingFrequency() }}
                  </div>
                </div>
              </li>
            </ul>
          </c-card-body>
        </c-card>
      </c-col>

      <!-- Features to Remove -->
      <c-col xs="12" md="6" *ngIf="featureComparison.featuresToRemove.length > 0">
        <c-card class="h-100 border-danger">
          <c-card-header class="bg-danger-subtle">
            <h6 class="mb-0 text-danger fw-semibold">
              <svg cIcon name="cilMinus" class="me-2"></svg>
              Features to Remove ({{ featureComparison.featuresToRemove.length }})
            </h6>
          </c-card-header>
          <c-card-body>
            <ul class="list-unstyled mb-0">
              <li *ngFor="let feature of featureComparison.featuresToRemove" class="mb-2 d-flex align-items-start">
                <svg cIcon name="cilX" class="text-danger me-2 mt-1 flex-shrink-0"></svg>
                <div>
                  <span>{{ feature.featureName }}</span>
                  <div class="small text-muted" *ngIf="feature.moduleName && feature.moduleName !== 'General'">
                    {{ feature.moduleName }}
                  </div>
                  <div class="small text-info" *ngIf="feature.price > 0">
                    ${{ getFeaturePrice(feature.price) }}{{ getBillingFrequency() }}
                  </div>
                </div>
              </li>
            </ul>
          </c-card-body>
        </c-card>
      </c-col>

      <!-- No Changes -->
      <c-col xs="12"
        *ngIf="featureComparison.featuresToAdd.length === 0 && featureComparison.featuresToRemove.length === 0">
        <c-alert color="info">
          <svg cIcon name="cilInfo" class="me-2"></svg>
          Both plans have the same features. Only the plan association will be updated.
        </c-alert>
      </c-col>
    </c-row>

    <!-- Upgrade Notice -->
    <c-row class="mt-4" *ngIf="featureComparison.isUpgrade">
      <c-col xs="12">
        <c-alert color="primary" class="mb-0">
          <strong>Important:</strong> After upgrading, please visit the <strong>Invoices</strong> section to pay the
          invoice and activate your new features.
        </c-alert>
      </c-col>
    </c-row>
  </c-modal-body>

  <c-modal-footer>
    <button cButton color="secondary" (click)="cancelPlanChange()" [disabled]="processingPlanChange">
      Cancel
    </button>
    <button cButton
      [color]="featureComparison?.isUpgrade ? 'success' : featureComparison?.isDowngrade ? 'warning' : 'primary'"
      (click)="confirmPlanChange()" [disabled]="processingPlanChange">
      <c-spinner *ngIf="processingPlanChange" size="sm" class="me-2"></c-spinner>
      <svg *ngIf="!processingPlanChange" cIcon name="cilCheckAlt" class="me-1"></svg>
      {{ processingPlanChange ? 'Processing...' : 'Confirm Change' }}
    </button>
  </c-modal-footer>
</c-modal>


<!-- Invoice Notification Modal -->
<c-modal [(visible)]="invoiceNotificationVisible" alignment="center" backdrop="static" size="md">
  <c-modal-header>
    <h5 cModalTitle class="text-success">
      <svg cIcon name="cilCheckCircle" class="me-2"></svg>
      Upgrade Successful!
    </h5>
    <button (click)="closeInvoiceNotification()" cButtonClose></button>
  </c-modal-header>

  <c-modal-body class="text-center py-4">
    <svg cIcon name="cilTask" size="4xl" class="text-success mb-3"></svg>
    <h5 class="mb-3">Your plan has been upgraded!</h5>
    <p class="text-muted mb-4">
      To activate your new features, please complete the payment for the invoice generated for this upgrade.
    </p>
    <c-alert color="info" class="text-start">
      <svg cIcon name="cilInfo" class="me-2"></svg>
      You can find the invoice in the <strong>Invoices</strong> section.
    </c-alert>
  </c-modal-body>

  <c-modal-footer class="justify-content-center">
    <button cButton color="secondary" variant="ghost" (click)="closeInvoiceNotification()">
      Close
    </button>
    <button cButton color="primary" (click)="goToInvoices()">
      <svg cIcon name="cilArrowRight" class="me-2"></svg>
      Go to Invoices
    </button>
  </c-modal-footer>
</c-modal>

<!-- Downgrade Notification Modal -->
<c-modal [(visible)]="downgradeNotificationVisible" alignment="center" backdrop="static" size="md">
  <c-modal-header>
    <h5 cModalTitle class="text-warning">
      <svg cIcon name="cilCheckCircle" class="me-2"></svg>
      Plan Downgraded Successfully!
    </h5>
    <button (click)="closeDowngradeNotification()" cButtonClose></button>
  </c-modal-header>

  <c-modal-body class="py-4">
    <div class="text-center mb-4">
      <svg cIcon name="cilTask" size="4xl" class="text-warning mb-3"></svg>
      <h5 class="mb-3">Your plan has been downgraded</h5>
    </div>

    <c-alert color="warning" class="mb-4">
      <svg cIcon name="cilWarning" class="me-2"></svg>
      <strong>Important Notice:</strong>
      <p class="mb-0 mt-2">
        Your plan downgrade will take effect from your next invoice date.
      </p>
      <p class="mb-0 mt-2" *ngIf="downgradeInvoiceDate">
        <strong>Next Invoice Date:</strong> {{ downgradeInvoiceDate | date : "MMM dd, yyyy" }}
      </p>
    </c-alert>

    <c-alert color="info" class="text-start">
      <svg cIcon name="cilInfo" class="me-2"></svg>
      <strong>What happens next?</strong>
      <p class="mb-0 mt-2">
        Until the next invoice date, you can continue using all the features of your current plan. After that date, your
        plan will be updated to the new downgraded plan.
      </p>
    </c-alert>
  </c-modal-body>

  <c-modal-footer class="justify-content-center">
    <button cButton color="primary" (click)="closeDowngradeNotification()">
      <svg cIcon name="cilCheckAlt" class="me-2"></svg>
      Got It
    </button>
  </c-modal-footer>
</c-modal>